export default "__VITE_ASSET__bf5fd42e__"